const vnLangSale = {
  'sale.helmet': 'Bán hàng',
  'sale.code': 'Mã',
  'sale.gift': 'Quà tặng',
  'sale.cash': 'Tiền mặt',
  'sale.number': 'Trị giá',
  'sale.percent': 'Quy đổi',
  'sale.maximum': 'Giảm tối đa',
  'sale.description': 'Mô tả',
  'sale.name': 'Tên',
  'sale.btn-unselect-discount': 'Bỏ chọn mã giảm giá',
  'sale.discount-placeholder': 'Chọn mã giảm giá',
  'sale.discount-empty-title': 'Hiện chưa có mã giảm giá/quà tặng nào.',
  'sale.create-order-success': 'Tạo đơn hàng thành công!',
  'sale.create-order-failure': 'Tạo đơn hàng không thành công! Vui lòng thử lại sau.',
  'sale.create-order-loading': 'Đang tiến hành tạo đơn hàng...',
  'sale.header.search-input.placeholder-1': 'Tìm hàng hoá',
  'sale.header.search-input.placeholder-2': 'Tìm đơn thuốc mẫu',
  'sale.header.order-tab-name': 'Hoá đơn',
  'sale.header.btn-delete-order-tab': 'Xoá',
  'sale.header.btn-add-order-tab': 'Thêm',
  'sale.header.link.admin': 'Trang quản lý',
  'sale.header.link.logout': 'Đăng xuất',
  'sale.header.btn-add-product': 'Thêm mới hàng hoá',
  'sale.footer.tab.sell-quickly': 'Bán nhanh',
  'sale.footer.tab.sell-casual': 'Bán thường',
  'sale.footer.btn-tutorial': 'Hướng dẫn sử dụng',
  'sale.footer.btn-letter': 'Góp ý',
  'sale.item.more-action.note': 'Ghi chú',
  'sale.item.more-action.detail': 'Chi tiết sản phẩm',
  'sale.item.note.placeholder': 'Ghi chú...',
  'sale.container.footer.note-placeholder': '✎ Ghi chú đơn hàng',
  'sale.container.footer.total-price-tmp': 'Tổng tiền hàng',
  'sale.sell-casual-tab.btn-filter': 'Lọc sản phẩm',
  'sale.sell-casual-tab.btn-view-mode-list': 'Chế độ danh sách',
  'sale.sell-casual-tab.btn-view-mode-thumbnail': 'Chế độ hình ảnh',
  'sale.sell-casual-tab.btn-payment': 'Thanh toán',
  'sale.sell-casual-tab.title-1': 'Tổng tiền hàng',
  'sale.sell-casual-tab.title-2': 'Giảm giá',
  'sale.sell-casual-tab.title-3': 'Khách cần trả',
  'sale.sell-casual-tab.title-4': 'Khách thanh toán',
  'sale.sell-casual-tab.title-5': 'Tiền thừa trả khách',
  'sale.sell-casual-tab.payment-type.cash': 'Tiền mặt',
  'sale.sell-casual-tab.payment-type.bank': 'Chuyển khoản',
  'sale.sell-casual-tab.payment-type.card': 'Thẻ',
  'sale.sell-casual-tab.add-account-bank-title': 'Thêm tài khoản ngân hàng',
  'sale.loading-customer-title': 'Đang tìm kiếm...',
  'sale.search-customer-placeholder': 'Tìm khách hàng',
  'sale.btn-unselect-user': 'Bỏ chọn khách hàng',
  'sale.btn-add-user': 'Thêm khách hàng mới',
  'sale.select-discount': 'Chọn mã giảm giá',
  'sale.modal.customer.create.title': 'Thêm khách hàng mới',
  'sale.modal.customer.detail.title': 'Thông tin khách hàng',
  'sale.modal.customer.update.title': 'Cập nhật thông tin khách hàng',
  'sale.modal.customer.error-length-max': 'Tối đa $x ký tự!',
  'sale.modal.customer.name.col': 'Tên khách hàng',
  'sale.modal.customer.name.placeholder': 'Nguyễn Văn A',
  'sale.modal.customer.name.error-required': 'Vui lòng nhập tên khách hàng!',
  'sale.modal.customer.phone.col': 'Điện thoại',
  'sale.modal.customer.phone.placeholder': '08xxxxxxxx',
  'sale.modal.customer.phone.error-required': 'Vui lòng nhập số điện thoại!',
  'sale.modal.customer.phone.error-invalid': 'Số điện thoại không hợp lệ!',
  'sale.modal.customer.phone.is-exist': 'Số điện thoại đã được đăng ký!',
  'sale.modal.customer.email.col': 'Email',
  'sale.modal.customer.email.placeholder': 'email@example.com',
  'sale.modal.customer.email.error-invalid': 'Email không hợp lệ!',
  'sale.modal.customer.address.col': 'Địa chỉ',
  'sale.modal.customer.birthday.col': 'Ngày sinh',
  'sale.modal.note.create-customer.success': 'Thêm khách hàng mới thành công!',
  'sale.modal.note.create-customer.failure': 'Thêm khách hàng mới không thành công! Vui lòng thử lại sau.',
  'sale.modal.note.update-customer.success': 'Cập nhật thông tin khách hàng thành công!',
  'sale.modal.note.update-customer.failure': 'Cập nhật thông tin khách hàng không thành công! Vui lòng thử lại sau.',
  'sale.modal.btn-create': 'Thêm',
  'sale.modal.btn-update': 'Cập nhật',
  'sale.title-add-customer': 'Thêm khách hàng mới',
  'sale.modal.note.confirm.create-customer.title': 'Xác nhận thêm khách hàng',
  'sale.modal.note.confirm.create-customer.description': 'Bạn chắc chắn muốn thêm khách hàng <strong>$x</strong> này?',
  'sale.modal.note.confirm.update-customer.title': 'Xác nhận cập nhật thông tin khách hàng',
  'sale.modal.note.confirm.update-customer.description': 'Bạn chắc chắn muốn cập nhật thông tin khách hàng <strong>$x</strong> này?',
  'sale.modal.failure.title': 'Có lỗi xảy ra!',
  'sale.modal.failure.description': 'Vui lòng quay lại sau, hoặc bấm vào nút <strong>Làm mới</strong> để thử lại.',
  'sale.modal.failure.btn': 'Làm mới',
  'sale.btn.bill': 'Bán thuốc theo đơn',
  'sale.modal.bill.title': 'Thông tin đơn thuốc',
  'sale.modal.billCode.label': 'Mã đơn thuốc',
  'sale.modal.billCode.error-required': 'Vui lòng nhập mã đơn thuốc!',
  'sale.modal.doctor.label': 'Bác sĩ kê đơn',
  'sale.modal.hospital.label': 'Cơ sở khám bệnh',
  'sale.modal.name.label': 'Tên bệnh nhân',
  'sale.modal.age.label': 'Tuổi',
  'sale.modal.gender.label': 'Giới tính',
  'sale.modal.gender.male.label': 'Nam',
  'sale.modal.gender.female.label': 'Nữ',
  'sale.modal.weight.label': 'Cân nặng',
  'sale.modal.id_card.label': 'CCCD',
  'sale.modal.id_bhyt.label': 'Thẻ BHYT',
  'sale.modal.address.label': 'Địa chỉ',
  'sale.modal.phone.label': 'Điện thoại liên hệ',
  'sale.modal.note.label': 'Chuẩn đoán',
  'sale.modal.bill.btn.back': 'Bỏ qua',
  'sale.modal.bill.btn.save': 'Xong',
  'sale.failure.title.missing-customer': 'Vui lòng chọn khách hàng cho đơn hàng!',
  'sale.failure.description.missing-customer': 'Đối với khách vãng lai thì chọn <strong>Khách</strong>.',
  'sale.failure.description.missing-bill-code': 'Vui lòng nhập <strong>Mã đơn thuốc</strong> với đơn <strong>Bán thuốc theo đơn</strong>.',
  'sale.dropdown.bill-code': 'Mã đơn thuốc',
  'sale.dropdown.order-code': 'Mã đơn hàng',
  'sale.dropdown.username-name': 'Khách hàng',
  'sale.dropdown.username-phone': 'Số điện thoại',
  'sale.empty-bill-info': 'Hiện chưa có kết quả nào cho tìm kiếm của bạn.',
  'sale.staff.btn-remove': 'Bỏ chọn',
  'sale.staff-empty-title': 'Hiện không có nhân viên nào cùng ca với bạn.',
  'sale.staff-loading-title': 'Đang tải danh sách nhân viên trong ca...',
  'sale.dropdown.item.name': 'Tên',
  'sale.dropdown.item.phone': 'SĐT',
  'sale.dropdown.item.email': 'Email',
  'sale.cart-item-total': 'Thành tiền',
  'sale.modal.detail-product': 'Thông tin chi tiết sản phẩm',
  'sale.modal.detail-product.code.label': 'Mã sản phẩm',
  'sale.modal.detail-product.barcode.label': 'Mã vạch',
  'sale.modal.detail-product.name.label': 'Tên sản phẩm',
  'sale.modal.detail-product.image.label': 'Hình ảnh',
  'sale.modal.detail-product.source.label': 'Nguồn gốc / Xuất xứ',
  'sale.modal.detail-product.unit.label': 'Đơn vị tính',
  'sale.modal.detail-product.desc.label': 'Mô tả sản phẩm',
  'sale.modal.detail-product.price.label': 'Giá bán',
  'sale.screen-filter-product.title': 'Lọc sản phẩm',
  'sale.screen-filter-product.sub-title-category': 'Danh mục sản phẩm',
  'sale.screen-filter-product.all': 'Tất cả',
  'sale.screen-filter-product.btn-clear': 'Xoá chọn',
  'sale.screen-filter-product.btn-back': 'Quay lại',
  'sale.screen-filter-product.btn-accept': 'Lọc',
  'sale.inventory': 'Số lượng trong kho',
  'sale.inventory-empty': 'Hết hàng',
  'sale.quantity': 'SL',
  'sale.modal.work-places.title': 'Chọn địa điểm lên đơn',
  'sale.modal.error-msg-work-place-require': 'Vui lòng chọn địa điểm lên đơn!',
  'sale.modal.work-places.btn-submit': 'Lên đơn',
  'sale.barcode-scanner': 'Quét mã vạch',
  'sale.render-qr-code.title': 'Thông tin chuyển khoản',
  //
  'sale.fnb.tab-table': 'Phòng bàn',
  'sale.fnb.tab-menu': 'Thực đơn',
  'sale.fnb.tab-order': 'Hoá đơn',
  'sale.fnb.all': 'Tất cả',
  'sale.fnb.used': 'Sử dụng',
  'sale.fnb.empty': 'Còn trống',
  'sale.fnb.bring-back': 'Mang về',
  'sale.fnb.modal-note-table.title': 'Ghi chú phòng / bàn',
  'sale.fnb.modal-note-table.title-2': 'Ghi chú món ăn',
  'sale.fnb.modal-note-table.title-3': '✎ Ghi chú / Món thêm',
  'sale.fnb.modal-note-table.btn.done': 'Xong',
  'sale.fnb.modal-note-table.btn.cancel': 'Bỏ qua',
  'sale.fnb.open-menu-when-select-table': 'Mở thực đơn khi chọn bàn',
  'sale.fnb.note-section.description': '✎ Nhập ghi chú',
  'sale.fnb.order-item-note': 'Nhập Ghi chú / Món thêm',
  'sale.fnb.notify-content': '<i class="simple-icon-bell"></i> Bạn vừa cập nhật đơn hàng. Bấm nút <span>Thông báo</span> để gửi thông tin chế biến đến bar bếp.',
  'sale.fnb.btn-payment': 'Thanh toán',
  'sale.fnb.btn-notify': 'Thông báo',
  'sale.fnb.notify-success': 'Bếp đã nhận được thông báo',
  'sale.fnb.form-payment.btn.note': 'Ghi chú',
  'sale.fnb.form-payment.btn.decoupling': 'Tách ghép',
  'sale.fnb.form-payment.btn.total': 'Tổng tiền',
  'sale.fnb.order-bring-back': 'Hoá đơn mang về',
  'sale.fnb.order-table': 'Hoá đơn',
  'sale.fnb.modal-decoupling.title-1': 'Ghép đơn',
  'sale.fnb.modal-decoupling.title-2': 'Tách đơn',
  'sale.fnb.modal-decoupling.title-3': 'Ghép đến',
  'sale.fnb.modal-decoupling.title-4': 'Chọn phòng / bàn',
  'sale.fnb.modal-decoupling.title-5': 'Bàn chưa có món nào',
  'sale.fnb.modal-decoupling.title-6': 'Khách hàng',
  'sale.fnb.modal-decoupling.title-7': 'Số lượng hàng',
  'sale.fnb.modal-decoupling.title-8': 'Tổng tiền',
  'sale.fnb.modal-decoupling.title-9': 'Khách lẻ',
  'sale.fnb.modal-decoupling.title-10': 'Tạo đơn mới',
  'sale.fnb.modal-decoupling.title-11': 'SL trên đơn gốc',
  'sale.fnb.modal-decoupling.title-12': 'SL tách',
  'sale.fnb.modal-decoupling.btn-1': 'Thực hiện',
  'sale.fnb.modal-decoupling.btn-2': 'Bỏ qua',
  'sale.fnb.modal-decoupling.noti-grafted': 'Ghép đơn thành công!',
  'sale.fnb.modal-decoupling.noti-detached': 'Tách đơn thành công!',
  'sale.fnb.noti-order-success': 'Tạo hoá đơn và thanh toán thành công!',
  'sale.fnb.noti-order-failure': 'Tạo hoá đơn và thanh toán không thành công! Vui lòng thử lại sau.',
};

export default vnLangSale;
